import { defineAsyncComponent } from 'vue'
import { tabOutlineInfoCircle } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { DrawerFeatureTwin, FeatureConfig } from 'src/models'

export interface InfoFeatureTwin extends DrawerFeatureTwin {
  showTwinId?: boolean
  showActions?: boolean
  showOutgoingTwins?: boolean
}

const featureConfig: FeatureConfig = {
  drawer: {
    drawerComponent: defineAsyncComponent(() => import('./InfoFeatureDrawerMain.vue')),
    icon: tabOutlineInfoCircle,
    label: 'Info'
  }
}

export default featureConfig
